import * as React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Form, useNotify, required } from 'ra-core';
// eslint-disable-next-line import/no-extraneous-dependencies
import { TextInput } from 'ra-ui-materialui';
import { Button, CardContent } from '@mui/material';
import { useState } from 'react';
import { useDataProvider, useLogin } from 'react-admin';

const steps = {
	phone: 'phone',
	code: 'code',
};

const styles = {
	QRButton: {
		display: 'block',
		width: '100%',
		marginBlockStart: '0.5rem',
	},
};

const useSMSFormController = () => {
	const [step, setStep] = useState(steps.phone);
	const [requestId, setRequestId] = useState();
	const notify = useNotify();
	const provider = useDataProvider();
	const login = useLogin();

	const requestCode = (phone) => {
		return provider.runCloudFunction('requestVerificationCodeByLogin', { phone })
			.then(({ data: { requestId: id } }) => {
				notify(
					`Код отправлен на ${phone}`,
					{
						type: 'success',
					},
				);
				setRequestId(id);
			});
	};

	const checkCode = (code) => {
		return provider.runCloudFunction('checkVerificationCode', { requestId, verificationCode: code })
			.then(({ data: { sessionId } }) => login({ sessionToken: sessionId }))
			.then(() => provider.runCloudFunction('confirmRegistration', { requestId }));
	};

	const submit = (formData) => {
		if (step === steps.phone) {
			return requestCode(formData.phone)
				.then(() => { setStep(steps.code); })
				.catch(({ message }) => {
					notify(
						`Ошибка ${message}`,
						{
							type: 'error',
						},
					);
				});
		}
		return checkCode(formData.code)
			.then(() => {})
			.catch(({ message }) => {
				notify(
					`Ошибка ${message}`,
					{
						type: 'error',
					},
				);
			});
	};

	return { step, submit };
};

const PhoneForm = ({ onSubmit }) => {
	return (
		<Form onSubmit={onSubmit} defaultValues={{ phone: '', code: '' }}>
			<CardContent>
				<TextInput
					source="phone"
					name="phone"
					label="Телефон"
					fullWidth
					validate={required('Укажите номер телефона')}
				/>
				<Button
					style={styles.QRButton}
					type="submit"
				>
					Получить код
				</Button>
			</CardContent>
		</Form>
	);
};

const CodeForm = ({ onSubmit }) => {
	return (
		<Form onSubmit={onSubmit} defaultValues={{ phone: '', code: '' }}>
			<CardContent>
				<TextInput
					source="code"
					name="code"
					label="Код из СМС"
					fullWidth
					validate={required('Укажите код из СМС')}
				/>
				<Button
					style={styles.QRButton}
					type="submit"
				>
					Проверить
				</Button>
			</CardContent>
		</Form>
	);
};

const SMSLoginForm = () => {
	const { step, submit } = useSMSFormController();
	return (
		step === steps.phone
			? (
				<PhoneForm onSubmit={submit} />
			)
			: (
				<CodeForm onSubmit={submit} />
			));
};

export default SMSLoginForm;
